module.exports = "<svg xmlns=http://www.w3.org/2000/svg width=48 height=48 viewBox=\"0 0 48 48\"><path d=\"M40 8H8c-2.21 0-3.98 1.79-3.98 4L4 36c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H8V24h32v12zm0-20H8v-4h32v4z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/upgrade.svg
// module id = 298
// module chunks = 0